import { useEffect, useState } from 'react';
import { Carousel, Spinner } from '@taxdown/piccolo-web';
import { useGetUserPlan } from 'Containers/Plans/hooks';
import { FRONT_PLANS, parsePlans } from 'Constants/plans';
import { PlansType } from 'Types/common';
import CardPlan from '../CardPlan';

export type MobileSlider = {
  plans: PlansType[];
  info: { plan?: PlansType[]; isVip: boolean; planRecommended?: FRONT_PLANS };
};

const MobileSlider = ({ plans, info: planInfo }: MobileSlider): JSX.Element => {
  const [info, setInfo] = useState<PlansType>();
  const userPlan = useGetUserPlan();
  useEffect(() => {
    if (!info) {
      const defaultPlan = plans.filter(
        data =>
          (parsePlans(data.name) === FRONT_PLANS.PRO && !data.subscribed) ||
          parsePlans(data.name) === FRONT_PLANS.FULL
      );
      setInfo(defaultPlan[0]);
    }
  }, []);

  const isSubscribed =
    planInfo.plan?.some(plan => plan.subscribed) || userPlan === FRONT_PLANS.FLEX_LITE;
  const planFull = planInfo.plan?.find(plan => plan.name === FRONT_PLANS.FULL);
  const getPlanInfo = planInfo.plan && planInfo.plan.length === 1 ? planInfo.plan[0] : info;

  const getPlanRecommended = planInfo?.plan?.find(
    item =>
      parsePlans(item.name) ===
      (planInfo.planRecommended ? parsePlans(planInfo.planRecommended) : undefined)
  );

  const selectedTab =
    planInfo && planInfo.plan && planInfo.planRecommended ? getPlanRecommended : getPlanInfo;

  return info && plans ? (
    <Carousel
      mode="dark"
      items={plans?.map(plan => (
        <CardPlan
          plan={plan}
          key={plan.id}
          plansAmount={planInfo?.plan?.length}
          recommendPlan={planInfo.plan || []}
          planSelect={planInfo.planRecommended}
        />
      ))}
      goToSlide={
        isSubscribed && planFull
          ? plans.indexOf(planFull)
          : plans.indexOf(selectedTab || (planInfo.plan?.length === 1 ? planInfo.plan[0] : info))
      }
    />
  ) : (
    <Spinner size="M" />
  );
};

export default MobileSlider;
